export const CHANGE_HEADER_FOOTER_STATE = "CHANGE_HEADER_FOOTER_STATE"
export const START_PAGE = "START_PAGE"
export const PAGE_SHOW_NEXT = "PAGE_SHOW_NEXT"
export const COMPLETE_PAGE = "COMPLETE_PAGE"
export const CHANGE_LOADING_OVERLAY_STATE = "CHANGE_LOADING_OVERLAY_STATE"